// Imports
import planMapping from './plan-mapping';
import specialSizes from './special-sizes';
import subscriptionAmountMapping from './subscription-amount-mapping';
import extendedPricingDetails from './extended-pricing-details';


/** Determine all valid non-special sizes for a given subscription plan */
export default function availableSubscriptionSizes(plan: (typeof planMapping)[keyof typeof planMapping]) {
	// Handle Free plan
	if (plan === planMapping.free) {
		return [specialSizes.FREE_PLAN];
	}
	
	
	// Retrieve plan
	const basePlanSizes = Object.keys(subscriptionAmountMapping[plan]).map((size) => parseInt(size));
	
	
	// Retrieve extended pricing details
	const extendedPricing = plan in extendedPricingDetails ? extendedPricingDetails[plan] : null;
	
	
	// Determine extended plan sizes
	const extendedPlanSizes = extendedPricing
		? new Array((extendedPricing.end - extendedPricing.start) / extendedPricing.step)
				.fill(0)
				.map((_x, i) => (i + 1) * extendedPricing.step + extendedPricing.start)
		: [];
	
	
	// Return
	return [...basePlanSizes, ...extendedPlanSizes];
}
